import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { LocalizationService } from '../../../../internationalization/localization.service';

/**
 * Represents a language option.
 */
interface ILanguageOption {
  name: string;
  selected: boolean;
  country: {
    name: string;
    code: string;
  };
}

/**
 * Component for language switch functionality.
 */
@Component({
  selector: 'app-language-switch',
  imports: [CommonModule, SharedModule],
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss'],
})
export class LanguageSwitchComponent implements OnInit {
  /**
   * Array of language options.
   */
  languageOptions: ILanguageOption[] = [
    { name: 'en', selected: true, country: { name: 'English', code: 'en' } },
    // { name: 'vn', selected: false, country: { name: 'VietNam', code: 'vn' } },
    { name: 'zh', selected: false, country: { name: 'Taiwan', code: 'tw' } },
  ];

  /**
   * Instance of the LocalizationService.
   */
  localizeService = inject(LocalizationService);

  /**
   * The currently selected language.
   */
  readonly currentLanguage: string | null;

  /**
   * Initializes a new instance of the LanguageSwitchComponent class.
   */
  constructor() {
    this.currentLanguage = localStorage.getItem('language');
  }

  /**
   * Initializes the component.
   */
  ngOnInit(): void {
    this.languageOptions.forEach((option) => {
      option.selected = option.name === this.currentLanguage;
    });
  }

  get activeLanguage(): string {
    return this.languageOptions.find((o) => o.selected)?.name ?? this.currentLanguage ?? 'en';
  }
  async changeLanguage(language: string) {
    localStorage.setItem('language', language);
    await this.localizeService.useLanguage(language).then(() => {
      location.reload();
    });
  }
}
